var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtsy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.115V3.115H5.885L9 0L12.115 3.115H18V17.115H0ZM1 16.115H17V4.115H1V16.115ZM4.5 13.615H13.654L10.827 9.845L8.212 13.153L6.462 11.038L4.5 13.615ZM13.928 9.115C14.2387 9.115 14.5013 9.006 14.716 8.788C14.9307 8.57067 15.038 8.30633 15.038 7.995C15.038 7.68367 14.9293 7.42067 14.712 7.206C14.494 6.99133 14.2297 6.884 13.919 6.884C13.6083 6.884 13.345 6.993 13.129 7.211C12.915 7.42833 12.808 7.69267 12.808 8.004C12.808 8.31533 12.9167 8.57833 13.134 8.793C13.352 9.00767 13.6167 9.115 13.928 9.115ZM7.138 3.115H10.862L9 1.253L7.138 3.115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtsy);
export default __webpack_public_path__ + "static/media/artsy.2508ac1055976528a003b30073f9eb80.svg";
export { ForwardRef as ReactComponent };